export enum HTTPMethods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum HTTPStatusCodes {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

export enum ErrorMessages {
  LOGIN_FAILED = "Login failed",
  INVALID_CREDENTIALS = "Invalid credentials",
  NETWORK_ERROR = "Network error",
  VALIDATION_ERROR = "Validation error",
  UNKNOWN_ERROR = "An unknown error occurred",
}

export const ValidationPatterns = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 8,
  NAME_MIN_LENGTH: 2,
} as const;

export enum Timeouts {
  API_REQUEST = 30000, // 30 seconds
  DEBOUNCE = 300, // 300ms
  THROTTLE = 1000, // 1 second
}
